import { render, staticRenderFns } from "./ModeratorRegisterRootView.vue?vue&type=template&id=64c25009"
import script from "./ModeratorRegisterRootView.vue?vue&type=script&lang=js"
export * from "./ModeratorRegisterRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports